<template>
    <q-page>
        <div class="q-display-1">Ankiety</div>

        <SurveyComponent
            class="survey"
            v-for="survey in items"
            :key="survey.surveyId"
            :model="survey"
            :inline="true"/>

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="add_circle"
                color="primary"
                @click="addNew">
                <q-tooltip anchor="top left">
                    Dodaj nowy
                </q-tooltip>
            </q-btn>
        </fixed-buttons>

    </q-page>
</template>

<script>
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import SurveyViewer from './pole/viewers/SurveyViewer'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import SurveyComponent from './pole/SurveyComponent'
    import FixedButtons from './FixedButtons'
    export default {
        name: 'Surveys',
        components: {FixedButtons, SurveyComponent, QBtn, QTooltip, SurveyViewer, QIcon},
        data() {
            return {

            }
        },
        computed: {
            items () {
                if (this.$route.name === 'surveys-qualifying') {
                    return this.$store.getters.qualifyingSurvey
                } else {
                    return this.$store.getters.regularSurvey
                }
            }
        },
        methods: {
            addNew () {
                if (this.$route.name === 'surveys-qualifying') {
                    this.$router.push({name: 'survey-add-qualifying'})
                } else {
                    this.$router.push({name: 'survey-add'})
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .survey {
        min-height: 200px;
    }
</style>